import { Component, OnInit, Inject, Output, EventEmitter, Input } from "@angular/core";
import { UMPCategory, Utils } from '../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ActivatedRoute, Params } from '@angular/router';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';

interface MersyKPIGropouFunctionNode {
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: MersyKPIGropouFunctionNode;


    id: string,
    text: string,
    type: string,
    icon: string,
    state: any,
    securityStatus: number,
    isAssigned: boolean,
    isTenantNode: boolean,
    canAssign: boolean,
    canUnassign: string,
    children: MersyKPIGropouFunctionNode[]

}

@Component({
    selector: "group-mersykpigroupfunction",
    templateUrl: './mersykpigroupfunction.component.html',
    styleUrls: ['./mersykpigroupfunction.component.less'],
    standalone: false
})

export class GroupMersyKPIGroupFunction implements OnInit {
    @Input() public groupmgmtcallback: Function | undefined;
    @Output() secondaryTenUpdate = new EventEmitter<{ selTen: string[], checked: boolean }>();

    public TREE_DATA: MersyKPIGropouFunctionNode[] = [];/*** */

    public selectedNodes: string[] = [];
    public unSelectedNodes: string[] = [];

    public treeControl: NestedTreeControl<MersyKPIGropouFunctionNode>;
    public dataSource = new MatTreeNestedDataSource<MersyKPIGropouFunctionNode>();

    public searchString = '';
    public showOnlySelected = false;

    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API

    isCallSucceed: number = 0;

    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.MersyKPIGroupFunction
    }

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private route: ActivatedRoute,
        private defaults: DefaultValuesService) {

        this.treeControl = new NestedTreeControl<MersyKPIGropouFunctionNode>((node) => node.children)
    }

    ngOnInit() {
        this.route.params.subscribe(
            (params: Params) => {
                this.resetAll();
            });
    }

    ngOnChanges() {
        this.functGetUserMersyKPI();
    }

    resetAll() {
        this.treeControl = new NestedTreeControl<MersyKPIGropouFunctionNode>((node) => node.children);
        this.dataSource = new MatTreeNestedDataSource<MersyKPIGropouFunctionNode>();
        this.functGetUserMersyKPI();
    }

    functGetUserMersyKPI() {
        Utils.httpGetMersyKPIGroupFunction(
            this.http
            , this.baseUrl
            , this
            , (tthis: GroupMersyKPIGroupFunction, data: any) => {

                tthis.TREE_DATA = [data.rootTenantNodes];

                tthis.treeControl.dataNodes = tthis.TREE_DATA;
                tthis.dataSource.data = tthis.TREE_DATA;
                Object.keys(tthis.dataSource.data).forEach((key) => {
                    tthis.setParent(tthis.dataSource.data[key], undefined);
                }
                )
                tthis.preselect();

            });
    }

    public hideLeafNode(node: MersyKPIGropouFunctionNode): boolean {
        return new RegExp(this.searchString, 'i').test(node.text) === false;
    }

    public itemToggle(checked: boolean, node: MersyKPIGropouFunctionNode, manualUpdate: boolean = false) {

        if (manualUpdate) {
            this.searchTenant(checked, node);
        }
        node.selected = checked;
        if (node.children && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);

        }
        if (node.children) {
            this.itemDisable(checked, node);
        }
        if (manualUpdate) {
            if (checked) {
                this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.id)
                if (this.unSelectedNodes.find(e => e === node.id))
                    this.data.SelectedBranches.push(node.id)
            }
            else {
                this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.id)
                if (node.canUnassign)
                    this.data.UnselectedBranches.push(node.id)
            }
        }
        this.checkAllParents(node);
    }

    private searchTenant(checked: boolean, node: MersyKPIGropouFunctionNode) {
        if (node.isTenantNode) {
            this.secondaryTenUpdate.emit({ selTen: [this.extractText(node.text)], checked });
        }
        else {
            this.searchTenantInDesc(checked, node);
        }
    }

    private itemUnselect(node: MersyKPIGropouFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.selected ? this.data.UnselectedBranches.push(node.id) : null; node.indeterminate = false; node.selected = false; });
    }

    private itemDisable(checked: boolean, node: MersyKPIGropouFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => node.disabled = checked);
    }

    private checkAllParents(node: MersyKPIGropouFunctionNode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    extractText = (input: string) =>
        input.replace(/\s+/g, '').split('(')[0];

    private searchTenantInDesc(checked: boolean, node: MersyKPIGropouFunctionNode) {
        const descendants = this.treeControl.getDescendants(node);
        var tenNode = descendants.filter(node => node.isTenantNode);
        if (tenNode.length > 0) {
            var selTen = tenNode.map((node) => this.extractText(node.text))
            this.secondaryTenUpdate.emit({ selTen, checked });
        }
        else {
            this.searchTenantInParent(checked, node);
        }
    }

    private searchTenantInParent(checked: boolean, node: MersyKPIGropouFunctionNode) {
        if (node.parent) {
            node.parent.isTenantNode ? (this.secondaryTenUpdate.emit({ selTen: [this.extractText(node.parent.text)], checked })) : null;
            this.searchTenantInParent(checked, node.parent);
        }
    }

    public hideParentNode(node: MersyKPIGropouFunctionNode): boolean {
        if (
            !this.searchString ||
            node.text.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        ) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.text
                        .toLowerCase()
                        .indexOf(this.searchString.toLowerCase()) !== -1
            )
        ) {
            return false
        }

        return true
    }

    public hasChild = (_: number, node: MersyKPIGropouFunctionNode) =>
        !!node.children && node.children.length > 0

    private setParent(node: MersyKPIGropouFunctionNode, parent: MersyKPIGropouFunctionNode | undefined) {
        node.parent = parent;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private preselect() {
        this.unSelectedNodes = [] as string[];
        for (let i = 0; i < this.treeControl.dataNodes.length; i++) {

            if (this.treeControl.dataNodes[i].canUnassign) {
                this.itemToggle(true, this.treeControl.dataNodes[i]);
            }
            else
                this.unSelectedNodes.push(this.treeControl.dataNodes[i].id);
            if (this.treeControl.dataNodes[i].children) {
                const alldecendents = this.treeControl.getDescendants(this.treeControl.dataNodes[i]);
                for (let j = 0; j < alldecendents.length; j++) {
                    if (alldecendents[j].canUnassign) {
                        this.itemToggle(true, alldecendents[j]);
                    }
                    else
                        this.unSelectedNodes.push(alldecendents[j].id);
                }
            }

        }
    }

    itemSelected(ischecked, name, id) {
        if (ischecked) {
            this.onSelect(name, id);
        } else {
            this.onDeselect(name, id);
        }
    }

    onSelect(name, selectedid) {
        this.defaults.addGroupListItem({ Personae: name, Id: selectedid, UmpCategory: UMPCategory.MersyKPIGroupFunction });

    }

    onDeselect(name, selectedid) {
        this.defaults.removeGroupListItem(selectedid);

    }
}